import {
  Divider,
  FormCol, FormRow, PasswordControl,
  Spacing,
  moveWorkflowForwardByName,
} from 'ia-react-core';
import { Form, FormSection, useMarkPageLoaded } from 'omni-package-react-core';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AxiosResponse } from 'axios';
import AuthenticationFactors from '../../../../components/AuthenticationFactors';
import { getProfileApiRoot } from '../../../../utils/getProfileApiRoot';
import mapControlErrors from '../../../../utils/mapControlErrors';
import { BFFBadRequest } from '../../../../interfaces/BFFBadRequest';

export interface MfaConfirmationStepProps { }

const MfaPasswordStep: FC<MfaConfirmationStepProps> = () => {
  const { t } = useTranslation('MfaValidationPage');
  const dispatch = useDispatch();

  const formErrorsSelector = useCallback(() => ({
    code: t('steps.password.messages.formError'),
  }), [t]);

  const controlErrorsSelector = useCallback((response: AxiosResponse<BFFBadRequest>) => (
    mapControlErrors(response?.data)
  ), []);

  const handleSuccess = useCallback(() => {
    dispatch(moveWorkflowForwardByName('workflows.mfa', {
      hasConfirmedPassword: true,
    }, { replace: true, state: { pageView: true } }));
  }, [dispatch]);

  useMarkPageLoaded();

  return (
    <Form<{}, BFFBadRequest>
      url={`${getProfileApiRoot()}/account/authenticate`}
      name="forms.password"
      valuesDst="values.password"
      dataSrc="values.password"
      dataDst="data.password"
      defaultCol={12}
      cleanValues
      formErrorsSelector={formErrorsSelector}
      controlErrorsSelector={controlErrorsSelector}
      formTitle={t('steps.password.title')}
      infoMessageText={t('steps.password.info')}
      submitButtonText={t('steps.password.confirmButtonText')}
      messageBottomBorder={36}
      onSuccess={handleSuccess}
    >
      <FormSection>
        <Spacing m-b={36}>
          <AuthenticationFactors
            sectionTitle={t('steps.password.factorTitle')}
            readOnly
          />
        </Spacing>
        <Divider />
        <Spacing m-t={36} p-b={12}>
          <FormRow>
            <FormCol
              label={t('steps.password.passwordLabel')}
              data-testid="mfaPassword"
            >
              <PasswordControl
                name="password"
                required
              />
            </FormCol>
          </FormRow>
        </Spacing>
      </FormSection>
    </Form>
  );
};

export default MfaPasswordStep;
